import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-get-it-rapido-success-dialog',
  templateUrl: './get-it-rapido-success-dialog.component.html',
  styleUrls: ['./get-it-rapido-success-dialog.component.scss']
})
export class GetItRapidoSuccessDialogComponent {
  constructor(private activeModal: NgbActiveModal) {
  }

  public onClose() {
    this.activeModal.dismiss();
  }
}
